<template>
  <span v-if="step && step.level" class="text-nowrap">
    <b-badge :variant="badgeVariant">
      {{ step.statusName || '' }} {{ step.level }}
    </b-badge>
  </span>
  <span v-else>--</span>
</template>

<script>
import { WORKFLOW_APPROVAL_STEP_STATUS, APPROVER_STATUS } from '@/utils/enum';
import { APPROVER_STATUS_NAME } from '@/utils/enum-name';

const STATUS_VARIANT = {
  [WORKFLOW_APPROVAL_STEP_STATUS.PENDING]: 'warning',
  [WORKFLOW_APPROVAL_STEP_STATUS.APPROVED]: 'success',
  [WORKFLOW_APPROVAL_STEP_STATUS.REJECTED]: 'danger',
  [WORKFLOW_APPROVAL_STEP_STATUS.REFUND_APPROVED]: 'secondary',
  5: 'primary', // BROWSING (budget)
};

// Build from enums — maps lowercase statusName → variant
const NAME_VARIANT = Object.fromEntries([
  [APPROVER_STATUS_NAME[APPROVER_STATUS.PENDING].toLowerCase(), 'warning'],
  [APPROVER_STATUS_NAME[APPROVER_STATUS.APPROVED].toLowerCase(), 'success'],
  [APPROVER_STATUS_NAME[APPROVER_STATUS.REJECTED].toLowerCase(), 'danger'],
  [APPROVER_STATUS_NAME[APPROVER_STATUS.REVERTED].toLowerCase(), 'secondary'],
  ['đang duyệt', 'primary'], // BROWSING — no dedicated enum name entry
]);

export default {
  name: 'ApprovalStepBadge',
  props: {
    step: {
      type: Object,
      default: null,
    },
  },
  computed: {
    badgeVariant() {
      if (!this.step) return 'secondary';
      if (this.step.status != null) {
        const v = STATUS_VARIANT[Number(this.step.status)];
        if (v) return v;
      }
      const name = (this.step.statusName || '').trim().toLowerCase();
      return NAME_VARIANT[name] || 'secondary';
    },
  },
};
</script>
